module.exports = __webpack_public_path__ + "img/rsvp-ticket.55c8d705.svg";